<template>
  <div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: "wel",
    data(){
      return{

      }
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    created(){
      this.initDate()
    },
    methods:{

    },
  };
</script>

<style scoped="scoped" lang="scss">

</style>
